export const WEBREGEX = ''

/// Password Regex

export const lower = /^(?=.*[a-z])/;
export const upper = /^(?=.*[A-Z])/;
export const number = /^(?=.*[0-9])/;
export const length = /^(?=.{8,})/;
export const secuentialNumber = /(012|123|234|345|456|567|678|789)/;